import React from 'react';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { TcsmResourceBlock } from '../../models/tcsm-block-models';
import { TcsmContentLinkView } from '../tcsm-content-link';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';
import { ExternalLink } from '../external-link-modal';


interface Props {
    blockData: TcsmResourceBlock,
}

export const TcsmResourceBlockView = (props: Props) => {

    const { blockData } = props;

    const externalLinkTextNode = (
        <>
            {blockData?.viewAllText}<ArrowForwardIcon />
        </>
    );

    return (
        <div className='dashboard-resources'>
            <img className='dashboard-resources-image' src={blockData?.image} alt={blockData?.imageAltText} />
            <h3 className='dashboard-resources-title'>{blockData?.title}</h3>
            <div className='dashboard-resources-content'>
                <p className='dashboard-resources-subtitle'><strong>{blockData?.subtitle}</strong></p>
                <WysiwygWithReactLink content={blockData?.description}></WysiwygWithReactLink>
                <ul className='dashboard-resources-list'>
                    {
                        blockData?.links?.map((a, idx) => <li className='dashboard-resources-list-item' key={idx}><TcsmContentLinkView link={a} /></li>)
                    }
                    {
                        blockData?.viewAllLinkUrl &&
                        <li className='dashboard-resources-list-item'>
                            <ExternalLink
                                linkUrl={blockData?.viewAllLinkUrl}
                                linkText={externalLinkTextNode}
                                className='dashboard-resources-list-item-viewall' />
                        </li>
                    }
                </ul>
            </div>
        </div>

    );

};


